	import { useState, useCallback, ChangeEvent, useEffect } from "react";
	import { SearchInputForm } from "src/components/common/form/search/SearchInputForm";
	import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
	import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
	import { SearchDateRangeForm } from "src/components/common/form/search/SearchDateRangeForm";
	import { SearchCodeModalForm } from "src/components/common/form/search/SearchCodeModalForm";
	import { defaultTQC2050_R01Filter, useTQC2050_R01Store } from "./Store_TQC2050_R01";
	import { useCommonCodeStore } from "src/store/useCommonCodeStore";
	import useUiuxStore from "src/store/useUiuxStore";
	import { CompanyDto } from "src/dtos/company/companyDto";
	import { EmployeeDto } from "src/dtos/employee/employeeDto";
	import { SysCodeDto } from "src/dtos/code/sysCodeDto";
import { SearchSpacer } from "src/components/common/common";
import { SearchSectionDoubleForm } from "src/components/common/form/search/SearchSectionDoubleForm";
import { getEmployeeList } from "src/apis/employeeApi";
import { getMST4010_R01List } from "../../MST/MST4010_R01/Api_MST4010_R01";
import { MST4010_R01Dto } from "../../MST/MST4010_R01/Dto_MST4010_R01";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";
import { InfoCodeSearchFieldConfig } from "src/types/info-form";

	// Props 타입 정의: 엔터키 핸들러
	interface Props {
	onEnterKeyDown: () => void;
	}

	export const SearchSection_TQC2050_R01 = (props: Props) => {
	const { onEnterKeyDown } = props;

	const { TQC2050_R01Filter, setTQC2050_R01Filter } = useTQC2050_R01Store();
	const { compCdList, employeeCdList, carModelList } = useCommonCodeStore();
	const { setCodeSearchModalProps } = useUiuxStore();
	const [pickerVisible, setPickerVisible] = useState(false);
	const [pickerPosition, setPickerPosition] = useState<{ top: number; left: number }>({ top: 0, left: 0 });

	const handleEmpFoucsId = 'empNo_search';

	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'empNo',
			category: '시험자',
			focusId: handleEmpFoucsId,
			responseMapping: {
				empNo: 'empNo',
				empNm: 'empNm',
			},
			extraFilter: () => ({
				empNo: TQC2050_R01Filter.empNo || '',
				empNm: TQC2050_R01Filter.empNm || '',
			}),
		},
	];

	const { getFieldHandlers } = useInfoFormEvents({
		editData: TQC2050_R01Filter,
		setEditData: setTQC2050_R01Filter,
		defaultData: defaultTQC2050_R01Filter,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'TQC2050_R01_search'
	});

	return (
		<div className="w-full ">
				<SearchSectionDoubleForm >
				<SearchDropDownForm<CompanyDto>
				label="사업장"
				value={TQC2050_R01Filter.compCd}
				optionList={compCdList}
				onChangeValue={(v) => setTQC2050_R01Filter({ compCd: v === 'all' ? '' : v })}
				/>
				<SearchDateRangeForm
				label="검사일자"
				visible={pickerVisible}
				setVisible={setPickerVisible}
				dateRange={TQC2050_R01Filter.testDt}
				setDateRange={(v) => setTQC2050_R01Filter({ testDt: v })}
				pickerPosition={pickerPosition}
				setPickerPosition={setPickerPosition}
				/>
				<SearchCodeModalForm
				label="시험자"
				value={TQC2050_R01Filter.empNo}
				valueLabel={TQC2050_R01Filter.empNm}
				handleFoucsId={handleEmpFoucsId}
				onChange={getFieldHandlers('empNo').onChange}
				onDoubleClick={getFieldHandlers('empNo').onDoubleClick}
				onKeyDown={getFieldHandlers('empNo').onEnterKeyDown}
				/>

			</SearchSectionDoubleForm>
		</div> );
	};

	export default SearchSection_TQC2050_R01;

